import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export async function listDummyAccounts() {
  const { data } = await client.get('/dummy-accounts');
  return data.accounts || [];
}

export async function createDummyAccount(payload) {
  const { data } = await client.post('/dummy-accounts', payload);
  return data.account;
}

export async function deleteDummyAccount(id) {
  await client.delete(`/dummy-accounts/${id}`);
}

export async function testDummyAccountLogin(id) {
  const { data } = await client.post(`/dummy-accounts/${id}/test-login`);
  return data;
}

export async function setDummyAccountSessionid(id, sessionid) {
  const { data } = await client.post(`/dummy-accounts/${id}/set-sessionid`, { sessionid });
  return data.account;
}

const dummyAccountsService = {
  listDummyAccounts,
  createDummyAccount,
  deleteDummyAccount,
  testDummyAccountLogin,
  setDummyAccountSessionid,
};
export default dummyAccountsService;
